(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '@material-ui/core', '@material-ui/core/MenuItem', './SplitButtonMenuItem.styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('@material-ui/core'), require('@material-ui/core/MenuItem'), require('./SplitButtonMenuItem.styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.core, global.MenuItem, global.SplitButtonMenuItem);
    global.SplitButtonMenuItem = mod.exports;
  }
})(this, function (exports, _react, _core, _MenuItem, _SplitButtonMenuItem) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _MenuItem2 = _interopRequireDefault(_MenuItem);

  var _SplitButtonMenuItem2 = _interopRequireDefault(_SplitButtonMenuItem);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SplitButtonMenuItem = function SplitButtonMenuItem(_ref) {
    var clickHandler = _ref.clickHandler,
        classes = _ref.classes,
        children = _ref.children;
    return _react2.default.createElement(
      _MenuItem2.default,
      {
        className: classes.root,
        onClick: clickHandler,
        'data-test': 'click-split-button-menu-item'
      },
      children
    );
  };

  exports.default = (0, _core.withStyles)(_SplitButtonMenuItem2.default)(SplitButtonMenuItem);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/SplitButton/SplitButtonMenuItem.js
// module id = 1944
// module chunks = 1